<template lang="pug">
el-card.text-center.center
  div.clearfix(slot="header")
    h1 404
    h2 Page not found
  el-button(@click="goBack") Back
</template>

<script>
export default {
  methods: {
    goBack() {
      this.$router.go(-2);
    },
  },
};
</script>

<style lang="stylus" scoped>
.el-card
  width 300px

  &.center
    position absolute
    left 50%
    top 50%
    transform translate(-50%, -50%)
</style>



// WEBPACK FOOTER //
// src/components/404.vue